import React from "react";
import {
  Box,
  Button,
  Flex,
  Heading,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { FaTruck, FaUserTie, FaBox, FaIndustry, FaLink } from "react-icons/fa";
import Footer from "../components/footer";
import FrotaTab from "./configuracao/FrotaTab";
import MotoristasTab from "./configuracao/MotoristasTab";
import ProdutosTab from "./configuracao/ProdutosTab";
import FornecedoresTab from "./configuracao/FornecedoresTab";
import VinculoMotoristaVeiculoTab from "./configuracao/VinculoMotoristaVeiculoTab";

const ConfiguracaoPage = () => {
  const navigate = useNavigate();
  const [tabIndex, setTabIndex] = React.useState(0);
  const INDEX_TAB_VINCULAR = 4;

  return (
    <Flex direction="column" minH="100vh" bg="gray.50">
      <Box flex="1" py={6} px={{ base: 4, md: 6 }}>
        <Box maxW="1400px" mx="auto">
          <Flex
            align="center"
            justify="space-between"
            mb={6}
            flexWrap="wrap"
            gap={4}
          >
            <Button
              leftIcon={<FaArrowLeft />}
              variant="outline"
              colorScheme="blue"
              onClick={() => navigate("/home")}
            >
              Voltar
            </Button>
            <Heading size="lg" color="#007abe">
              Configuração
            </Heading>
          </Flex>

          <Tabs
            colorScheme="blue"
            variant="enclosed-colored"
            index={tabIndex}
            onChange={setTabIndex}
          >
            <TabList flexWrap="wrap" gap={1}>
              <Tab gap={2}>
                <FaTruck size={14} />
                Frota
              </Tab>
              <Tab gap={2}>
                <FaUserTie size={14} />
                Motoristas
              </Tab>
              <Tab gap={2}>
                <FaBox size={14} />
                Produtos
              </Tab>
              <Tab gap={2}>
                <FaIndustry size={14} />
                Fornecedores
              </Tab>
              <Tab gap={2}>
                <FaLink size={14} />
                Vincular motorista ao veículo
              </Tab>
            </TabList>
            <TabPanels pt={4}>
              <TabPanel px={0}>
                <FrotaTab />
              </TabPanel>
              <TabPanel px={0}>
                <MotoristasTab />
              </TabPanel>
              <TabPanel px={0}>
                <ProdutosTab />
              </TabPanel>
              <TabPanel px={0}>
                <FornecedoresTab />
              </TabPanel>
              <TabPanel px={0}>
                <VinculoMotoristaVeiculoTab
                  isActive={tabIndex === INDEX_TAB_VINCULAR}
                />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Box>
      </Box>
      <Footer />
    </Flex>
  );
};

export default ConfiguracaoPage;
